import "./style.less";
import { List, Button } from "rsuite";
import React from "react";
import { Translation } from "react-i18next";

const SolutionPanel = (props) => {
  // const isMobile = props.isMobile;

  return (
    <Translation>{(t)=>(
      <div className="solution-panel">
        <img
          src="./images/stock_1.png"
          alt="stock-thinking"
          className="solution-img"
        />
        <div className="solution-text">
          <h2>Veja-se livre das caóticas folhas de cálculo, agora!</h2>
          <List>
            <List.Item>
              urlbuilder.online é uma solução abrangente de gestão de UTMs,
              totalmente personalizável às suas políticas e govrenança de medição,
              e que lhe permite construir, partilhar e sincronizar os seus UTMs.
            </List.Item>
            <List.Item>
              <ul>
                <li>
                  {t("home_page.body.our_solution.text_2")}
                </li>
                <li>Obtenha uma atribuição de media correcta!</li>
                <li>
                  Obtenha atributos de dados de campanha correctos, consistentes e
                  dignos de confiança!
                </li>
                <li>{t("home_page.body.our_solution.text_5")}</li>
              </ul>
            </List.Item>
            <List.Item>
              Assim, pode tomar decisões de gestão de campanha educadas, fiáveis e
              com impacto.
            </List.Item>
            <List.Item className="list-button-center">
              <Button className="button-primary ">
                Experimente agora Gratuitamente
              </Button>
            </List.Item>
          </List>
        </div>
      </div>
    )}</Translation>
  );
};

export default SolutionPanel;
